import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, catchError, map, exhaustMap } from 'rxjs/operators';
import { defer, of } from 'rxjs';
import { OnDemandActions } from './on-demand.actions';
import { ContentTypeService } from '@core/services/api/content-type.service';
import { FolderService } from '@core/services/api/folder.service';
import { VideoService } from '@core/services/api/video.service';

@Injectable()
export class OnDemandEffects {
  constructor(
    private actions$: Actions,
    private contentTypeService: ContentTypeService,
    private folderService: FolderService,
    private videoService: VideoService
  ) {}

  getContentTypes$ = createEffect(() => {
    return defer(() =>
      this.actions$.pipe(
        ofType(OnDemandActions.getContentTypes),
        switchMap(pagination =>
          this.contentTypeService.getPaginated(pagination, true).pipe(
            switchMap(res => of(OnDemandActions.getContentTypesSuccess(res))),
            catchError(error => of(OnDemandActions.error({ error: error.message })))
          )
        )
      )
    );
  });

  initCollections$ = createEffect(() => {
    return defer(() =>
      this.actions$.pipe(
        ofType(OnDemandActions.initCollections),
        switchMap(pagination =>
          this.folderService.getFolders(pagination).pipe(
            switchMap(res => of(OnDemandActions.initCollectionsSuccess(res))),
            catchError(error => of(OnDemandActions.error({ error: error.message })))
          )
        )
      )
    );
  });

  getCollections$ = createEffect(() => {
    return defer(() =>
      this.actions$.pipe(
        ofType(OnDemandActions.getCollections),
        switchMap(pagination =>
          this.folderService
            .getFolders(pagination)
            .pipe(switchMap(res => of(OnDemandActions.getCollectionsSuccess(res))))
        ),
        catchError(error => of(OnDemandActions.error({ error: error.message })))
      )
    );
  });

  getVideos$ = createEffect(() => {
    return defer(() =>
      this.actions$.pipe(
        ofType(OnDemandActions.getVideos),
        exhaustMap(pagination =>
          this.videoService.getVideos(pagination).pipe(
            map(res => OnDemandActions.getVideosSuccess(res)),
            catchError(error => of(OnDemandActions.error({ error: error.message })))
          )
        )
      )
    );
  });
}
